import React, { useCallback } from 'react';
// styles
import styled, { css } from 'styled-components';
import { weights } from 'utils/style';

const IconContainer = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
`;

const ActionsMenuItem = ({
  className,
  children,
  disabled,
  danger,
  onClick,
  icon,
  ...props
}) => {
  const onClickIfEnabled = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (disabled) return;
      onClick(e);
    },
    [disabled, onClick]
  );

  return (
    <li className={className} onClick={onClickIfEnabled} {...props}>
      <IconContainer>{icon}</IconContainer>
      {children}
    </li>
  );
};

export default styled(ActionsMenuItem)`
  width: 100%;
  height: 100%;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
  font-weight: ${weights('regular')};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 11px 13px;
  gap: 7px;
  background-color: var(--white);
  color: var(--grey900);
  svg {
    /* border: 1px solid red; */
    /* width: 16px; */
    /* height: 16px; */
    /* display: block;
    width: 24px;
    height: 24px */
  }
  svg,
  svg path {
    fill: var(--grey900);
  }
  svg rect {
    fill: transparent;
  }
  &:hover {
    background-color: var(--primary100);
  }
  ${(props) =>
    !!props.danger &&
    css`
      color: var(--error900);
      svg,
      svg path {
        fill: var(--error900);
      }
    `}
  ${(props) =>
    !!props.disabled &&
    css`
      cursor: default;
      color: var(--grey900);
      svg,
      svg path {
        fill: var(--grey900);
      }
      opacity: 0.6;
      &:hover {
        background-color: var(--white);
      }
    `}
`;
